import React, { useEffect } from 'react'
// import Sidebar from './sidebar/Sidebar'
import { Outlet, useNavigate } from 'react-router-dom'
import Header from './Header'
import { jwtDecode } from "jwt-decode";
import SidebarNew from './sidebar/SidebarNew';
import useAutoLogout from '../../utils/useAutoLogout';

const DashboardLayout = () => {
  
  const navigate = useNavigate();

    useAutoLogout();
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      const decoded = jwtDecode(token);
      localStorage.setItem("token", token);
      localStorage.setItem("name", decoded.name);
      localStorage.setItem("servicetype", decoded.servicetype);
      localStorage.setItem("auth", decoded.authLevel);
      localStorage.setItem("userRole", decoded.authLevel);
      localStorage.setItem("Roles", decoded.customRoles);
      localStorage.setItem("email", decoded.email);
      localStorage.setItem("countrycode", decoded.countrycode || decoded.countryCode || "");
      localStorage.setItem("region", decoded.region || decoded.Region || "");
      // Group access (support both token shapes)
      if (decoded.groupid !== undefined) {
        localStorage.setItem("groupid", String(decoded.groupid));
      }
      if (decoded.groupids !== undefined) {
        localStorage.setItem("groupids", JSON.stringify(decoded.groupids));
      }
      if (decoded.groupId !== undefined) {
        localStorage.setItem("groupid", String(decoded.groupId));
      }
      if (decoded.groupIds !== undefined) {
        localStorage.setItem("groupids", JSON.stringify(decoded.groupIds));
      }
      localStorage.setItem("SuperUser", decoded.authLevel === "L0" ? "1" : "0");
      params.delete("token");
      window.history.replaceState({}, "", `${window.location.pathname}`);
      navigate(`/dashboard/`);
    }
  }, [navigate]);


  return (
    <div className="dashboard-container w-screen h-screen flex">
      <div className="relative w-[17%]">
        {/* <Sidebar /> */}
        <SidebarNew />
      </div>

      <main className="content-area w-[83%] p-[1%] h-screen">
        <Header />
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
